const RECAPTCHA_KEY = '6LdLAqUpAAAAAKRvnZpzxKbRQEU4zkphe5ZE5dPl';
export default RECAPTCHA_KEY;
